/** The partner program pages in the console (19/10/2026). Twin of `it.ts`. */
export default {
  titolo: 'Partner program',
  sottotitolo: 'Who brings us companies, what they earn on those subscriptions and when we pay them.',
  metriche: {
    partner_attivi: 'Active partners',
    aziende_attive: 'Companies earning',
    da_decidere: 'To decide',
    da_pagare: 'To pay',
  },
  schede: {
    partner: 'Partners',
    aziende: 'Companies',
    liquidazioni: 'Payouts',
    profili: 'Plans and tax regimes',
    kit: 'Partner kit',
  },
  azioni: {
    ricarica: 'Reload',
    nuovo_partner: 'New partner',
    modifica: 'Edit',
    guarda_spazio: 'View their space',
    invita: 'Send the invitation',
    reinvita: 'Send the invitation again',
    sospendi: 'Suspend access',
    riattiva: 'Reactivate',
    cessa: 'End the relationship',
    ricalcola: 'Recalculate now',
    ricalcola_tutti: 'Recalculate all',
    abbina: 'Link a company',
    accetta: 'Accept',
    rifiuta: 'Reject',
    esclusiva: 'Exclusivity',
    esclusiva_regola: 'Back to {{mesi}} months',
    approva: 'Approve',
    fattura_ricevuta: 'Invoice received',
    pagata: 'Mark as paid',
    nuovo_profilo: 'New plan',
    nuovo_regime: 'New tax regime',
    spegni: 'Turn off',
    aggiungi_scaglione: 'Add a tier',
    togli_scaglione: 'Remove the tier',
    salva: 'Save',
    annulla: 'Cancel',
    altre_azioni: 'More actions',
    nuovo_materiale: 'New material',
    riaccendi: 'Turn back on',
  },
  stato_partner: {
    invitato: 'Invited',
    attivo: 'Active',
    sospeso: 'Suspended',
    cessato: 'Relationship ended',
  },
  stato_abbinamento: {
    registrata: 'Registered',
    da_decidere: 'To decide',
    attiva: 'Earning',
    rifiutata: 'Rejected',
    scaduta: 'Expired',
  },
  origine: {
    registrazione: 'Registered by the partner',
    link: 'From the partner link',
    a_mano: 'Linked by hand',
  },
  stato_liquidazione: {
    bozza: 'Draft',
    approvata: 'Approved',
    fattura_ricevuta: 'Invoice received',
    pagata: 'Paid',
  },
  soggetto: {
    persona_fisica: 'Individual',
    societa_di_persone: 'Partnership',
    societa_di_capitali: 'Limited company',
  },
  colonne: {
    partner: 'Partner',
    stato: 'Status',
    profilo: 'Plan',
    regime: 'Regime',
    aziende: 'Companies',
    azienda: 'Company',
    origine: 'Origin',
    registrata_il: 'Registered on',
    scade_il: 'Expires on',
    abbonata_dal: 'Subscribed since',
    periodo: 'Period',
    imponibile: 'Commissions',
    ritenuta: 'Withholding',
    cassa: 'Pension fund',
    netto: 'To transfer',
    scaglioni: 'Tiers',
    trattamento: 'Treatment',
  },
  filtri: {
    tutti_gli_stati: 'All statuses',
    cerca: 'Search by company, VAT number or partner',
  },
  vuoti: {
    partner: 'No partners. First you need a commission plan and a tax regime («Plans and tax regimes» tab).',
    aziende: 'No linked or registered companies.',
    liquidazioni: 'No payouts: drafts appear on their own at the end of each period.',
    profili: 'No commission plans.',
    regimi: 'No tax regimes.',
    materiali: 'The kit is empty. Create the first material: the sign-up invitation.',
  },
  partner: {
    dimostrativo: 'Demo',
    aziende_conteggio_one: '{{count}} company',
    aziende_conteggio_other: '{{count}} companies',
    codice: 'Code {{codice}}',
    entrato: 'Has signed in to partner.yumaos.com',
    non_entrato: 'Has not signed in yet',
    ogni_mesi_one: 'Paid every month',
    ogni_mesi_other: 'Paid every {{count}} months',
    frequenza_piattaforma: 'Platform frequency',
    regime_da_scegliere: 'To choose',
    senza_provvigioni: 'No commissions',
  },
  aziende: {
    in_lista: 'On the waiting list',
    scade: 'Expires on {{data}}',
    partita_iva: 'VAT number {{chiave}}',
    mai_pagato: 'Has not paid yet',
    contare_dal: 'Invoices count from {{data}}',
    esclusiva_attiva: 'Exclusive to {{fornitore}} until {{data}}',
    esclusiva_finita: 'Exclusivity with {{fornitore}} ended on {{data}}',
    esclusiva_a_mano: 'Set by hand',
    esclusive_non_lette: 'The suppliers’ exclusivity could not be read: {{motivo}}',
  },
  profili: {
    titolo_profili: 'Commission plans',
    aiuto_profili: 'The percentage on seats for each month of the company subscription. Numbers never change: create a new plan and turn off the old one. Companies already brought in keep the plan they had.',
    titolo_regimi: 'Tax regimes',
    aiuto_regimi: 'VAT, withholding tax and pension fund of the partner. All optional: Enasarco is not always involved.',
    spento: 'Off',
    scaglione: 'From month {{dal}} to month {{al}}: {{percentuale}}',
    scaglione_per_sempre: 'From month {{dal}} onwards: {{percentuale}}',
    senza_iva: 'No VAT',
    iva: 'VAT {{percentuale}}',
    ritenuta: 'withholding {{aliquota}} on {{base}}',
    senza_ritenuta: 'no withholding',
    cassa: '{{nome}}: {{nostra}} ours, {{sua}} theirs',
    senza_cassa: 'no pension fund',
  },
  scala: {
    etichetta: 'Commission scale: {{descrizione}}',
    oggi: 'Today it is at month {{mese}}: {{percentuale}}',
    mese: 'month {{mese}}',
  },
  liquidazioni: {
    periodo: 'From {{dal}} to {{al}}',
    movimenti_one: '{{count}} entry',
    movimenti_other: '{{count}} entries',
    fattura: 'Invoice {{numero}} of {{data}}',
    pagata_il: 'Paid on {{data}}',
    costo_nostro: 'It costs us {{importo}} (with our share of the pension fund)',
  },
  dialogo_partner: {
    titolo_nuovo: 'New partner',
    titolo_modifica: 'Edit the partner',
    sezione_chi: 'Who they are',
    sezione_fisco: 'Tax and payment details',
    sezione_compenso: 'Commission',
    nome: 'Full name',
    email: 'Email',
    email_aiuto: 'The invitation arrives here, and the partner signs in with this address (Google or password).',
    email_bloccata: 'The partner has already signed in: the email can no longer change.',
    lingua: 'Language',
    paese: 'Country',
    paese_aiuto: 'Two-letter code, e.g. IT',
    telefono: 'Phone',
    tipo_soggetto: 'Type of entity',
    soggetto_dal_partner: 'The partner states it',
    regime_dopo: 'To choose once the partner has given their details',
    senza_provvigioni: 'No commissions',
    senza_provvigioni_aiuto: 'For the YumaOS account: it invites like other partners and the companies it brings stay its own, but it earns nothing and has no payment details.',
    ragione_sociale: 'Company name',
    partita_iva: 'VAT number',
    codice_fiscale: 'Tax code',
    iban: 'IBAN',
    profilo: 'Commission plan',
    regime: 'Tax regime',
    frequenza: 'How often we pay',
    note: 'Notes',
    persona_rete: 'Network contact card',
    nessuna: 'None',
  },
  lingue: {
    it: 'Italian',
    en: 'English',
  },
  frequenze: {
    piattaforma: 'Like the platform (every 3 months)',
    mesi_one: 'Every month',
    mesi_other: 'Every {{count}} months',
  },
  dialogo_abbina: {
    gia_di: 'It currently belongs to {{nome}}.',
    titolo: 'Link a company to a partner',
    aiuto: 'For companies the partner brought in before having access. Commissions accrue on invoices paid from the chosen day.',
    azienda: 'Company',
    partner: 'Partner',
    contare_dal: 'Invoices count from',
    sostituisci: 'The company belongs to another partner: replace them',
    motivo: 'Why',
  },
  dialogo_esclusiva: {
    titolo: 'Exclusivity of «{{azienda}}»',
    fino_al: 'Exclusive until',
    fino_al_aiuto: 'A day already past removes the exclusivity: other suppliers can then make an agreement with it.',
    motivo: 'Why',
    salva: 'Save the exclusivity',
  },
  dialogo_motivo: {
    rifiuta_titolo: 'Reject «{{azienda}}»',
    motivo: 'Reason',
    motivo_aiuto: 'The partner will read it.',
  },
  dialogo_fattura: {
    titolo: 'Partner invoice',
    numero: 'Number',
    data: 'Date',
  },
  dialogo_pagata: {
    titolo: 'Payout paid',
    data: 'Transfer date',
  },
  dialogo_profilo: {
    titolo: 'New commission plan',
    nome: 'Name',
    nome_aiuto: 'e.g. «Romano Paolicelli 2026»',
    dal_mese: 'From month',
    al_mese: 'To month',
    percentuale: 'Percentage',
    per_sempre: 'Forever',
  },
  dialogo_regime: {
    titolo: 'New tax regime',
    nome: 'Name',
    nome_aiuto: 'e.g. «Limited company, Italy»',
    paese: 'Country',
    con_iva: 'The partner adds VAT',
    iva: 'VAT %',
    con_ritenuta: 'We withhold tax',
    aliquota: 'Rate %',
    base: 'On % of the commission',
    con_cassa: 'There is a pension fund',
    nome_cassa: 'Fund name',
    quota_nostra: 'Our share %',
    quota_partner: 'Partner share %',
  },
  problemi_profilo: {
    nome_mancante: 'The name is missing.',
    base_sconosciuta: 'Unknown commission base.',
    nessuno_scaglione: 'At least one tier is needed.',
    non_parte_dal_primo_mese: 'The first tier must start from month 1.',
    mese_non_valido: 'Tier {{n}} has invalid months.',
    percentuale_non_valida: 'Tier {{n}} has an invalid percentage (0-100).',
    buco_o_sovrapposizione: 'Tier {{n}} must start the month after the previous one ends.',
    scaglione_dopo_per_sempre: 'No tier can follow a «forever» tier.',
  },
  kit: {
    aiuto: 'What partners can send to their contacts: the sign-up invitation, video series, a video, a website page. Each material has its ready-made messages; the link inside carries the partner\'s invitation code, so whoever signs up stays theirs.',
    destinazione: 'Leads to',
    iscrizione: 'Sign-up invitation',
    settore: 'Sector: {{settore}}',
    tutti_i_settori: 'All sectors',
    lingua: 'Language: {{lingua}}',
    spento: 'Off',
    breve: 'Short WhatsApp',
    apri: 'Open the page',
  },
  tipo_materiale: {
    iscrizione: 'Sign-up invitation',
    serie_video: 'Video series',
    video: 'Video',
    pagina: 'Website page',
    pdf: 'PDF',
  },
  dialogo_materiale: {
    titolo_nuovo: 'New kit material',
    titolo_modifica: 'Edit the material',
    nome: 'Name',
    nome_aiuto: 'How the partner sees it: “Photovoltaic quote preview”.',
    descrizione: 'Description',
    descrizione_aiuto: 'One line to choose: “Five videos, twelve minutes in all”.',
    tipo: 'What it is',
    destinazione: 'Website page',
    destinazione_aiuto: 'The path on yumaos.com, with the language first: /en/videos/solar.',
    settore: 'Sector',
    settore_aiuto: 'Optional, lower case: fotovoltaico, serramenti, climatizzazione.',
    lingua: 'Language',
    ordine: 'Order',
    attivo: 'On: partners can see it',
    messaggi: 'The messages',
    segnaposti: 'Placeholders: {link} the invitation link (required), {nome} the contact name, {mittente} the sender.',
    whatsapp_breve: 'Short WhatsApp',
    whatsapp_lungo: 'Long WhatsApp',
    email_oggetto: 'Email subject',
    email_testo: 'Email text',
    anteprima: 'Preview of the short WhatsApp, for Mario from Renato Spiga',
  },
  problemi_materiale: {
    nome_mancante: 'Write the name.',
    tipo_non_valido: 'Choose what it is.',
    destinazione_mancante: 'Write the website page it leads to.',
    destinazione_non_valida: 'The page must be a yumaos.com path, like /en/videos/solar.',
    messaggio_mancante: 'The “{{campo}}” message is missing.',
    link_mancante: 'The “{{campo}}” message is missing {link}.',
    segnaposto_sconosciuto: 'The “{{campo}}” message has an unknown placeholder.',
    troppo_lungo: 'A text is too long.',
  },
  messaggi: {
    salvato: 'Saved.',
    invito_inviato: 'Invitation sent to {{email}}.',
    spazio_aperto: 'The space of {{nome}} is open in a new tab, read only for 30 minutes.',
    invito_non_inviato: 'The invitation did not go out: try again shortly.',
    ricalcolo_fatto: 'Done: {{aziende}} companies checked, {{movimenti}} new commissions, {{bozze}} drafts.',
    errore: 'Operation failed: {{messaggio}}',
    serve_profilo_e_regime: 'First create at least one commission plan and one tax regime.',
  },
} as const;
